import { render, staticRenderFns } from "./JLCT2View.vue?vue&type=template&id=274eedf5&"
import script from "./JLCT2View.vue?vue&type=script&lang=js&"
export * from "./JLCT2View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports